import ExhibitTypeForm from "./ExhibitTypeForm";

export default ExhibitTypeForm